export function seo({
  title,
  description,
}: {
  title: string
  description?: string
}) {
  const tags = [
    { title: `${title} | Coral Boards` },
    { name: 'description', content: description ?? '' },
  ]
  return tags
}
